//
//
//
//
//
//
//
//
//
//
//

const axios = require('axios')

export default {
  props: ['id', 'fixedMobile'],
  computed: {
    isMobile() {
      return this.$store.state.isMobile
    },
  },
  data() {
    return {
      loading: true,
      stream: null,
      options: null,
      message: null,
      scrollPosition: window.pageYOffset,
    }
  },
  components: { 

  },
  mounted() {
    this.loading = true
    this.message = null
    this.fetchVideo()
    this.handleScroll();
  },
  methods: {
      handleScroll() {
        window.addEventListener("scroll", () => {
          this.scrollNow()
        });
      },
      scrollNow() {
        this.scrollPosition = window.pageYOffset;
      },
      playerReady(player) {
        try {
          player.tech_.vhs.xhr.beforeRequest = function (options) {
            return options
          }
        } catch(e){}
      },
      async fetchVideo() {
        let id = this.id;
        const response_stream = await this.$cached().$get('/v1/imgarena/stream/'+id, {
          params: {
            language: this.lang,
            bookmaker: process.env.BOOKMAKER
          }
        })

        try {
          const response_hls = await axios.get(_.get(response_stream, 'stream'))
          this.loading = false     
          console.log('response_hls', response_hls);     
          this.stream = _.get(response_hls, 'data.hlsUrl')


          this.options = {
            // videojs and plugin options
            aspectRatio: "9:5",
            //fluid : true,
            playsinline: true,
            autoplay: true,
            muted: true,
            sources: [
              {
                withCredentials: false,
                type: 'application/x-mpegURL',
                src: this.stream
              }
            ],
            controlBar: {
              playToggle: false,
              captionsButton: false,
              chaptersButton: false,
              subtitlesButton: false,
              remainingTimeDisplay: false,
              fullscreenToggle: false,
              volumeBar: false,
              playbackRateMenuButton: false,
              timeDivider: false,
              durationDisplay: false
            },
            flash: { hls: { withCredentials: false } },
            html5: { hls: { withCredentials: false } }
          }
        } catch(e) {
          console.log('fetchVideo', _.get(e, 'response.data.message'));

          this.message = _.get(e, 'response.data.message')
          console.log('fetchVideo', this.stream);
        }
      }
  }
}
